import React, {
  useState,
} from 'react';
import Dialog from 'pages/Dashboard/components/Dialog';
import TextAreaWithActions from 'pages/Dashboard/components/TextAreaWithActions';

const COMMENT_MAX_LENGTH = 128;
const DEFAULT_TITLE = 'Mark as submitted';
const DEFAULT_CANCEL_TEXT = 'Cancel';

type Props = {
  title?: string;
  cancelText?: string;
  isSubmitting?: boolean;
  onClose: () => void;
  onConfirm: (comment: string) => void;
};

export default function MarkAsSubmittedDialog({
  title = DEFAULT_TITLE,
  cancelText = DEFAULT_CANCEL_TEXT,
  isSubmitting = false,
  onClose,
  onConfirm,
}: Props) {
  const [comment, setComment] = useState('');

  return (
    <Dialog
      open
      title={title}
      confirmText="Mark"
      cancelText={cancelText}
      showActions
      disableConfirmButton={isSubmitting}
      onClose={onClose}
      onConfirm={() => onConfirm(comment)}
    >
      <TextAreaWithActions
        id="mark-submitted-comment"
        placeholder="Add comment"
        rows={3}
        value={comment}
        onChange={setComment}
        maxLength={COMMENT_MAX_LENGTH}
        trackingLabel="Mark Submitted Comment"
      />
    </Dialog>
  );
}
